import { all } from 'redux-saga/effects';

import { appSaga } from '../modules/app';
import { authSaga } from '../modules/auth';
import { companySaga } from '../modules/company';
import { companyFieldsScoresSaga } from '../modules/companyFieldsScores';
import { companyFilterSagas } from '../modules/companyFilter';
import { profileSaga } from '../modules/profile';
import { reviewSaga } from '../modules/review';

export default function * rootSaga () {
  yield all([
    appSaga(),
    authSaga(),
    companySaga(),
    reviewSaga(),
    profileSaga(),
    companyFilterSagas(),
    companyFieldsScoresSaga()
  ]);
}
